import { render, staticRenderFns } from "./VgImageUploader.vue?vue&type=template&id=afa96be0&scoped=true&"
import script from "./VgImageUploader.vue?vue&type=script&lang=js&"
export * from "./VgImageUploader.vue?vue&type=script&lang=js&"
import style0 from "./VgImageUploader.vue?vue&type=style&index=0&id=afa96be0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa96be0",
  null
  
)

export default component.exports